
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Ahemdabadwarmer() {



  const cardData =
  {
    keyword: 'Patient Warmer in Ahmedabad',
    heading: 'Pharmacle Health Care Private Limited: Patient Warmer in Ahmedabad',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warmer in Ahmedabad, ensuring effective temperature management for patients during surgeries and critical care. Our advanced patient warmers help prevent hypothermia by delivering consistent and controlled heat, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warmers are reliable, easy to use, and designed with cutting-edge technology. Choose Pharmacle Health Care for the best warming solutions in Ahmedabad to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "High-Quality Patient Warmers in Ahmedabad for Medical Excellence",
    "description": "Pharmacle Health Care Private Limited provides advanced patient warmers in Ahmedabad, ensuring optimal temperature management for surgical, ICU, and post-operative patients. Our cutting-edge devices help prevent hypothermia and improve patient recovery outcomes."
  },
  {
    "title": "Best Patient Warmers for Hospitals and Clinics in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited offers precision-controlled patient warmers designed for hospitals and clinics in Ahmedabad. These warming systems reduce risks during surgeries and critical care treatments, ensuring patient safety and comfort at every stage."
  },
  {
    "title": "Surgical Patient Warmers for Optimal Temperature Regulation in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited’s surgical patient warmers are essential for maintaining normothermia during procedures in Ahmedabad’s hospitals. They help minimize post-operative complications, improve surgical efficiency, and support better patient outcomes."
  },
  {
    "title": "Portable Patient Warmers for Emergency Medical Care in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited supplies compact and portable patient warmers suitable for ambulances and emergency response units in Ahmedabad. These advanced systems provide immediate thermal management, stabilizing patients during transport and trauma care."
  },
  {
    "title": "Neonatal Patient Warmers for NICUs and Maternity Wards in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited offers neonatal patient warmers specially designed for NICUs and maternity wards in Ahmedabad. These systems provide gentle and precise warmth for premature and low-birth-weight infants, ensuring safe and effective thermal regulation."
  },
  {
    "title": "Forced-Air Patient Warmers for Efficient Heat Distribution in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited provides forced-air patient warmers engineered for uniform temperature distribution. Ideal for operating theaters, recovery rooms, and ICUs in Ahmedabad, these systems deliver consistent warming and reliable patient care."
  },
  {
    "title": "Reliable Patient Warming Solutions for Post-Surgical Recovery in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited’s patient warmers support faster post-surgical recovery by maintaining body temperature, reducing shivering, and ensuring comfort. Widely used in Ahmedabad’s healthcare facilities, they promote improved healing outcomes."
  },
  {
    "title": "Advanced Patient Warmers for Critical Care Units in Ahmedabad",
    "description": "Pharmacle Health Care Private Limited manufactures ICU-grade patient warmers for Ahmedabad’s critical care departments. These systems deliver precise, continuous temperature regulation, reducing the risks of hypothermia in severely ill and critical patients."
  },
  {
    "title": "Innovative Patient Warmers for Private Healthcare Facilities in Ahmedabad",
    "description": "Private hospitals and specialty medical centers in Ahmedabad trust Pharmacle Health Care Private Limited for reliable and innovative patient warmers. Our devices are engineered for efficiency, safety, and compliance with global medical standards."
  },
  {
    "title": "Comprehensive Patient Warming Systems in Ahmedabad for Faster Recovery",
    "description": "Pharmacle Health Care Private Limited provides a complete range of patient warming systems in Ahmedabad, designed to improve circulation, minimize surgical risks, and promote faster recovery. Trusted by healthcare providers for superior patient care."
  }
],

      "services": [
        {
            "name": "Patient Warmer Ahmedabad",
            "description": "Pharmacle Health Care offers patient warmers in Ahmedabad, designed to maintain optimal body temperature during medical procedures. These warmers help prevent hypothermia and ensure a safe and comfortable environment for patients throughout surgeries and recovery."
        },
        {
            "name": "Ahmedabad Warming Systems",
            "description": "We provide warming systems in Ahmedabad, designed to regulate body temperature during medical treatments. These systems are crucial for preventing temperature-related complications and ensuring patient comfort and safety during surgeries and recovery."
        },
        {
            "name": "Forced Air Warming Devices Ahmedabad",
            "description": "Our forced air warming devices in Ahmedabad are designed to circulate warm air and maintain body temperature during medical procedures. These devices are effective in preventing hypothermia and ensuring patient safety and comfort during surgeries and recovery."
        },
        {
            "name": "Patient Thermoregulation Equipment Ahmedabad",
            "description": "We offer patient thermoregulation equipment in Ahmedabad, designed to maintain an optimal body temperature during medical treatments. These systems help regulate temperature fluctuations, ensuring a safe and comfortable environment for patients throughout their care."
        },
        {
            "name": "Ahmedabad Patient Temperature Control Devices",
            "description": "Pharmacle Health Care provides patient temperature control devices in Ahmedabad, essential for regulating body temperature during surgeries and critical care. These devices help prevent temperature-related complications and ensure a controlled and comfortable environment for patients."
        }
    ],
    "tableData": [
        ["- Patient Warmer Ahmedabad", "- Ahmedabad Warming Systems"],
        ["- Forced Air Warming Devices Ahmedabad", "- Patient Thermoregulation Equipment Ahmedabad"],
        ["- Ahmedabad Patient Temperature Control Devices"]
    ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warmers in Ahmedabad, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the Ahmedabad region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warmers in Ahmedabad, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warmers are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our warmers provide optimal reliability for continuous use in medical settings throughout Ahmedabad."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our patient warmers provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Ahmedabad are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warmers in Ahmedabad are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warmers are designed for seamless integration with existing medical systems in Ahmedabad. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Ahmedabad to help healthcare facilities select the right patient warmers for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warmers are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Ahmedabad receives the highest standard of care."
    }
]


















  }

  const faqData = [
    { question: "What is a Forced Air Warming System?", answer: "A Forced Air Warming System is a medical device used to regulate and maintain a patient’s body temperature during surgeries and medical procedures. It works by blowing warm air through a special warming blanket or pad placed over the patient." },
    { question: "How does the Forced Air Warming System work?", answer: "The system works by using a blower to circulate warm air through a blanket or pad that is placed on the patient’s body. This helps prevent hypothermia by maintaining the patient’s body temperature within a safe and comfortable range." },
    { question: "Is the Forced Air Warming System available in Ahmedabad?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Warmer in Ahmedabad, providing hospitals and healthcare facilities with an effective solution to maintain patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Forced Air Warming System?", answer: "The benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, speeding up recovery times, and ensuring a stable body temperature throughout medical procedures." },
    { question: "How long can the Forced Air Warming System maintain the patient’s temperature?", answer: "The Forced Air Warming System can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and temperature control." },
    { question: "Is the Forced Air Warming System easy to use?", answer: "Yes, the system is designed to be user-friendly, with simple controls that allow healthcare professionals to adjust the temperature settings quickly and efficiently." },
    { question: "Can the Forced Air Warming System be used for all types of surgeries?", answer: "Yes, the Forced Air Warming System is versatile and can be used in a wide range of surgeries and medical procedures, particularly those where maintaining normothermia is essential for patient safety." },
    { question: "Is the Forced Air Warming System safe for all patients?", answer: "Yes, the system is generally safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating or underheating." },
    { question: "How can I purchase a Forced Air Warming System in Ahmedabad?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Forced Air Warming System to your healthcare facility in Ahmedabad." },
    { question: "Does Pharmacle Health Care provide support for the Forced Air Warming System?", answer: "Yes, we offer complete support for the Forced Air Warming System, including installation, training for healthcare professionals, and ongoing maintenance to ensure optimal performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Warmer from Pharmacle Health Care in our Ahmedabad hospital. It has helped ensure that our patients stay at the correct temperature during surgeries, improving both comfort and safety.',
      name: 'Dr. Ramesh Patel',
    },
    {
      text: 'The Patient Warmer from Pharmacle Health Care has been a great addition to our clinic in Ahmedabad. It is easy to use, reliable, and provides consistent warmth to our patients during medical treatments.',
      name: 'Ahmedabad Medical Clinic',
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warmer in Ahmedabad",
    "description": "Explore advanced Patient Warmers in Ahmedabad for effective patient thermoregulation and temperature control during medical treatments. Our warming systems ensure optimal comfort and safety.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.6",
      "ratingCount": "1745"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Warmer in Ahmedabad | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Patient Warmers in Ahmedabad for effective temperature regulation and patient thermoregulation during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warmer Ahmedabad, Ahmedabad Warming Systems, Forced Air Warming Devices Ahmedabad, Patient Thermoregulation Equipment Ahmedabad, Ahmedabad Patient Temperature Control Devices"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ahemdabadwarmer;